<template>
  <path
    d="M0.394581 7.8664L6.15977 13.2198C6.4797 13.5169 7 13.29 7 12.8534L7 2.14661C7 1.71002 6.4797 1.48314 6.15977 1.78021L0.394581 7.1336C0.181549 7.33142 0.181548 7.66858 0.394581 7.8664Z"
    fill="currentColor"
  />
  <path
    d="M15.1313 13.6578C11.8945 10.6301 10.2936 10.5054 6.50138 10.5002C6.22524 10.4998 6 10.2761 6 10L6 5C6 4.72386 6.22594 4.49895 6.50188 4.5096C12.546 4.74291 15.4553 9.18862 15.9299 13.2959C15.9811 13.7384 15.4566 13.9621 15.1313 13.6578Z"
    fill="currentColor"
  />
</template>
